export class BusinessQueryParameters {
  destinationId?: string;
  id?: string;
  name?: string;
  oemId?: string;
  page?: number;
  pageSize?: number;

  constructor(obj?: BusinessQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
